/* eslint-disable react/jsx-pascal-case */
import {
  Box,
  Button,
  Checkbox,
  FormControl,
  IconButton,
  MenuItem,
  MenuList,
  Pagination,
  Popover,
  Radio,
  Select,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography
} from "@mui/material";
import React from "react";
import useEmotionStyles from "@styles/shared/useEmotionStyles";
import { TableHomeTaskStlye } from "@styles/layout/TableHomeTaskStlye";
import clsx from "clsx";
import { observer } from "mobx-react";
import { ReactComponent as DeleteSubMenu } from "@common/images/DeleteSubMenu.svg";
import { ReactComponent as DotsMoreMenu } from "@common/images/DotsMoreMenu.svg";
import { ReactComponent as SelectIcon } from "@common/images/SelectIcon.svg";
import { ReactComponent as BoardTextDelete } from "@common/images/BoardTextDelete.svg";
import { useTranslation } from 'react-i18next';
import {
  curriculumMap,
  schoolDict,
  gradeDict,
  subjectAreaDict,
  subjectDict,
  unitDict,
  achievementCodeDict
} from "@common/NewCurriculumCodes/CurriculumMap";
import { useNavigate, useParams } from "react-router-dom";
import { useStores } from "@hooks/useStores";
import dayjs from "dayjs";
import { ProjectSchoolType } from "@stores/enums/ProjectStoreEnums";
import { MessageDialog } from "@components/common";
import useNaviCustom from "@hooks/useNaviCustom";
import { useNeoConfirm } from "@hooks/useNeoConfirm";

type Props = {};

interface AchievementStandard {
  id: number;
  // labels
  schoolLevel: string;
  gradeGroup: string;
  subject: string; // 교과(군)
  course: string;  // 과목
  area: string;    // 영역(단원)
  code: string;    // 성취기준 코드
  name: string;    // 성취기준명
  // codes (for robust filtering)
  schoolCode: number;
  gradeCode: number;
  subjectAreaCode: number;
  subjectCode: number;
  unitCode: number;
}

function TempProjectCreateBasicInfo(props: Props) {
  const params = useParams();
  const i18next = useTranslation();
  const classes = useEmotionStyles(TableHomeTaskStlye);
  const navigate = useNavigate();

  const maxLenName = 500;

  

  // -----------------------------
  // Hierarchical selections (codes)
  // -----------------------------
  const [selSchool, setSelSchool] = React.useState<number | ''>('');
  const [selGrade, setSelGrade] = React.useState<number | ''>('');
  const [selSubjectArea, setSelSubjectArea] = React.useState<number | ''>('');
  const [selSubject, setSelSubject] = React.useState<number | ''>('');
  const [selUnit, setSelUnit] = React.useState<number | ''>('');
  const [selAchievement, setSelAchievement] = React.useState<string | ''>('');

  // project create required field
	const [projectName, setProjectName] = React.useState('');
	const [selectedId, setSelectedId] = React.useState<number | null>(null);

  // menus
  const [dotsMoreMenuAnchorEl, setDotsMoreMenuAnchorEl] = React.useState<null | HTMLElement>(null);

  // table selection + pagination
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);

  const [searchTextFree, setSearchTextFree] = React.useState("");

  const [dialogType, setDialogType] = React.useState(0);
  const [openDialog, setOpenDialog] = React.useState(false);
	const dialogIsConfirm = [true, true, false];
//
// -- project loading
  const { projectStore, authStore, navigateStore } = useStores();
  const { project } = projectStore;
  const { loginUser } = authStore;
  const [projectCode, setProjectCode] = React.useState('');
  
  const naviCustom = useNaviCustom();
  const {alert, confirm} = useNeoConfirm();

  // project reloading
	React.useEffect(() => {
		const code = params.projectCode;
		setProjectCode(code);
	}, [params]);

	React.useEffect(() => {
		if (!projectCode) {
			projectStore.initProject();


				// kitty
				// 현재 년도를 가져와서 과제명에 추가
				const year = dayjs().format('YYYY');
				projectStore.changeCirriculumYear(year);

				//
				projectStore.changeSchoolType(ProjectSchoolType.NOGRADE);


				projectStore.changeIsConfirmForUpdateRequired(false);
			

			return;
		}

		const fetchProjectInfo = async (code: string) => {
			try {
				const data = await projectStore.downloadProjectInfoAndStore(code);
				if (!data) {
					navigate('/', { replace: true }); // 프로젝트 정보가 없으면 메인 페이지로 이동
				} else {
					
					const projectName = projectStore.project.name;
					const curriculumCode = projectStore.project.newACurriculumCode;

					setProjectName(projectName);
					setSelectedId(curriculumCode);
//					setInitialized(true); // 프로젝트 정보가 제대로 로드된 경우 초기화 설정
				}
			} catch (error) {
				console.error("Error fetching project info:", error);
			}
		}
		fetchProjectInfo(projectCode); // 비동기 함수 호출

		// projectStore.getProjectInfo(projectCode)
		// 	.then(data => {
		// 		if (!data) {
		// 			naviCustom.go('/', true);
		// 			// props.navigate('/', {replace: true});
		// 		} else {
		// 			projectStore.getProjectPlanTransfer(projectCode);
		// 			setInitialized(true);
		// 		}
		// 	})
	}, [projectCode]);

	React.useEffect(() => {
		if (!projectStore.isConfirmForUpdateRequired
			|| navigateStore.isConfirmForUpdateRequired
		) return;

		navigateStore.changeIsConfirmForUpdateRequired(true);
	}, [projectStore.isConfirmForUpdateRequired]);

	React.useEffect(() => {
		if (project && project.name)
			setProjectName(project.name);
	}, [project.name])

	//
	// - dialogue
	const [dialogTitleText, setDialogTitleText] = React.useState([
		i18next.t("저장 하시겠습니까?"),
		i18next.t("저장하고 다음으로 넘어가시겠습니까?"),
		i18next.t("과제 개요가 저장 되었습니다.")
	]);

	const handleClickClose = () => {
		setOpenDialog(false);
	}


  // -----------------------------
  // Data shaping
  // -----------------------------
  const rows = React.useMemo(() => {
    return Object.entries(curriculumMap).map(([id, d]) => {
      const schoolLabel = schoolDict[d.schoolCode] ?? `학교급${d.schoolCode}`;
      const gradeLabel = gradeDict[d.gradeCode] ?? `학년군${d.gradeCode}`;
      const subjectAreaLabel = subjectAreaDict[d.subjectAreaCode] ?? `교과${d.subjectAreaCode}`;
      const subjectLabel = subjectDict[d.subjectCode] ?? `과목${d.subjectCode}`;
      const unitLabel = unitDict[d.unitCode] ?? `영역${d.unitCode}`;
      const achName = achievementCodeDict[d.achievementCode] ?? `성취기준 ${d.achievementCode}`;

      return {
        id: Number(id),
        schoolLevel: schoolLabel,
        gradeGroup: gradeLabel,
        subject: subjectAreaLabel,
        course: subjectLabel,
        area: unitLabel,
        code: d.achievementCode,
        name: achName,
        schoolCode: d.schoolCode,
        gradeCode: d.gradeCode,
        subjectAreaCode: d.subjectAreaCode,
        subjectCode: d.subjectCode,
        unitCode: d.unitCode
      } as AchievementStandard;
    });
  }, []);

	  // put near other state
	const resetBelow = (level: 'school'|'grade'|'subjectArea'|'subject'|'unit') => {
		if (level === 'school') {
			setSelGrade(''); setSelSubjectArea(''); setSelSubject(''); setSelUnit(''); setSelAchievement('');
		} else if (level === 'grade') {
			setSelSubjectArea(''); setSelSubject(''); setSelUnit(''); setSelAchievement('');
		} else if (level === 'subjectArea') {
			setSelSubject(''); setSelUnit(''); setSelAchievement('');
		} else if (level === 'subject') {
			setSelUnit(''); setSelAchievement('');
		} else if (level === 'unit') {
			setSelAchievement('');
		}
	};

	const [applied, setApplied] = React.useState({
		school: '' as number | '',
		grade: '' as number | '',
		subjectArea: '' as number | '',
		subject: '' as number | '',
		unit: '' as number | '',
		achievement: '' as string | '',
		searchText: '' as string,
	});


  // Unique helper
  const uniq = <T,>(arr: T[]) => Array.from(new Set(arr));

  // Options for each hierarchy level (derived from current selections)
  const schoolOpts = React.useMemo(
    () => uniq(rows.map(r => r.schoolCode)).sort((a, b) => a - b),
    [rows]
  );

  const gradeOpts = React.useMemo(
    () =>
      uniq(
        rows
          .filter(r => (selSchool === '' ? true : r.schoolCode === selSchool))
          .map(r => r.gradeCode)
      ).sort((a, b) => a - b),
    [rows, selSchool]
  );

  const subjectAreaOpts = React.useMemo(
    () =>
      uniq(
        rows
          .filter(r =>
            (selSchool === '' ? true : r.schoolCode === selSchool) &&
            (selGrade === '' ? true : r.gradeCode === selGrade)
          )
          .map(r => r.subjectAreaCode)
      ).sort((a, b) => a - b),
    [rows, selSchool, selGrade]
  );

  const subjectOpts = React.useMemo(
    () =>
      uniq(
        rows
          .filter(r =>
            (selSchool === '' ? true : r.schoolCode === selSchool) &&
            (selGrade === '' ? true : r.gradeCode === selGrade) &&
            (selSubjectArea === '' ? true : r.subjectAreaCode === selSubjectArea)
          )
          .map(r => r.subjectCode)
      ).sort((a, b) => a - b),
    [rows, selSchool, selGrade, selSubjectArea]
  );

  const unitOpts = React.useMemo(
    () =>
      uniq(
        rows
          .filter(r =>
            (selSchool === '' ? true : r.schoolCode === selSchool) &&
            (selGrade === '' ? true : r.gradeCode === selGrade) &&
            (selSubjectArea === '' ? true : r.subjectAreaCode === selSubjectArea) &&
            (selSubject === '' ? true : r.subjectCode === selSubject)
          )
          .map(r => r.unitCode)
      ).sort((a, b) => a - b),
    [rows, selSchool, selGrade, selSubjectArea, selSubject]
  );

  const achievementOpts = React.useMemo(
    () =>
      uniq(
        rows
          .filter(r =>
            (selSchool === '' ? true : r.schoolCode === selSchool) &&
            (selGrade === '' ? true : r.gradeCode === selGrade) &&
            (selSubjectArea === '' ? true : r.subjectAreaCode === selSubjectArea) &&
            (selSubject === '' ? true : r.subjectCode === selSubject) &&
            (selUnit === '' ? true : r.unitCode === selUnit)
          )
          .map(r => r.code)
      ),
    [rows, selSchool, selGrade, selSubjectArea, selSubject, selUnit]
  );

  // Reset cascade when parent selection changes
  React.useEffect(() => { setSelGrade(''); setSelSubjectArea(''); setSelSubject(''); setSelUnit(''); setSelAchievement(''); }, [selSchool]);
  React.useEffect(() => { setSelSubjectArea(''); setSelSubject(''); setSelUnit(''); setSelAchievement(''); }, [selGrade]);
  React.useEffect(() => { setSelSubject(''); setSelUnit(''); setSelAchievement(''); }, [selSubjectArea]);
  React.useEffect(() => { setSelUnit(''); setSelAchievement(''); }, [selSubject]);
  React.useEffect(() => { setSelAchievement(''); }, [selUnit]);

  const norm = (s: string) => s.toLowerCase();

  // Apply hierarchical filtering to table rows
  const filteredStandards = React.useMemo(() => {

	const tokens = applied.searchText ? applied.searchText.split(/\s+/).filter(Boolean).map(norm): [];

	const f = rows.filter(r => {
		// hierarchy filters
		if (applied.school !== '' && r.schoolCode !== applied.school) return false;
		if (applied.grade !== '' && r.gradeCode !== applied.grade) return false;
		if (applied.subjectArea !== '' && r.subjectAreaCode !== applied.subjectArea) return false;
		if (applied.subject !== '' && r.subjectCode !== applied.subject) return false;
		if (applied.unit !== '' && r.unitCode !== applied.unit) return false;
		if (applied.achievement !== '' && r.code !== applied.achievement) return false;

		// free-text filter
		if (tokens.length === 0) return true;

		const haystack = [
		r.code,
		r.name,                   // 성취기준명
		r.subject,                // 교과 label
		r.course,                 // 과목 label
		r.area,                   // 영역(단원) label
		r.schoolLevel,            // 학교급 label
		r.gradeGroup,             // 학년군 label
		].join(' ').toLowerCase();

		return tokens.every(t => haystack.includes(t));
	});

	// deduplicate by composite key
	const seen = new Set<string>();
	const unique = f.filter(r => {
		const key = [
			r.code,
			r.name,
			r.subject,
			r.course,
			r.area,
			r.schoolLevel,
			r.gradeGroup,
		].join('|'); // unique signature

		if (seen.has(key)) return false;
		seen.add(key);
		return true;
	});

	return unique;

	}, [rows, applied]);


  React.useEffect(() => { setPage(0); }, [filteredStandards.length]);

  // name handlers
  const handleChangeName = (e: React.ChangeEvent<HTMLInputElement>) => {
    const v = e.target.value ?? "";
    if (v.length > maxLenName) return;
    setProjectName(v);
    projectStore.changeName(v);
  };
  const handleClearName = () => {
    setProjectName('');
    projectStore.changeName('');
  };
  const remainingNameTextLen = React.useMemo(() => (projectName ? maxLenName - projectName.length : 0), [projectName]);

  // menu + bulk select handlers
  const handleClickDotsMoreMenu = (event: React.MouseEvent<HTMLElement>) => setDotsMoreMenuAnchorEl(event.currentTarget);
  const handleClosePopover = () => setDotsMoreMenuAnchorEl(null);
  
    const handleClickDelete = async () => {
		const accepted = await confirm(i18next.t("평가과제를 삭제하시겠습니까?"));
		if (!accepted) {
			handleClosePopover();
			return;
		}

		projectStore.deleteProject();

		await alert(i18next.t("삭제되었습니다."));

		resetIsConfirmForUpdateRequired();
        handleClosePopover();
		naviCustom.go(`/projects`, true);
    };

  const handleClickSave = () => {
		setDialogType(0);
		setOpenDialog(true);
	};
  const handleClickNextBtn = () => {
		setDialogType(1);
		setOpenDialog(true);
	}

  const handleClickConfirmBtn = () => {
		setOpenDialog(false);
		processAfterStorage();
		naviCustom.go(`/projects/${projectCode}/create/info`, true);
		// props.navigate(`/projects/${projectCode}/create/info`, {replace: true});
}

const handleClickNext = async () => {
		const currentProjectCode = await processProject();
		if (!currentProjectCode) return;
		setOpenDialog(false);
		processAfterStorage();
		naviCustom.go(`/projects/${currentProjectCode}/create/question`, true);
		// props.navigate(`/projects/${currentProjectCode}/create/question`, {replace: true});
	}

	

const handleClickTemporalStorage = async () => {
		const projectCode = await processProject();
		if (!projectCode) return;

		setOpenDialog(false);

		processAfterStorage();
		naviCustom.go(`/projects/${projectCode}/create/info`, true);
		// props.navigate(`/projects/${projectCode}/create/info`, {replace: true});
	}

	const processAfterStorage = () => {
		resetIsConfirmForUpdateRequired();
	};

	const resetIsConfirmForUpdateRequired = () => {
		navigateStore.changeIsConfirmForUpdateRequired(false);
		projectStore.changeIsConfirmForUpdateRequired(false);
	};


	const processProject = async () => {
		const data = await createOrUpdateProject();
		if (!data) return;

		const projectCode = data?.code;
		return projectCode;
	}

	const createOrUpdateProject = async () => {
		if (!projectCode) {
			// 새로 만드는 경우
			console.log("create project");
			const ret = await projectStore.createProjectForTemplate(loginUser.code, projectName, selectedId);
			return ret;
		} else {
			// 기존 과제를 업데이트하는 경우
			console.log("update project");
			const ret = await projectStore.updateTempProject(loginUser.code, projectName, selectedId);
			return ret;
		}
	}

  const paginatedStandards = React.useMemo(
    () => filteredStandards.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage),
    [filteredStandards, page, rowsPerPage]
  );


  const handleClickPage = (event: React.ChangeEvent<unknown>, value: number) => {
    setPage(value - 1);
  };

  const handleSelectStandard = (id: number) => setSelectedId(id);

  const isNextButtonDisabled = !projectName || selectedId === null;


  const ellipsis1 = {
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
};

const clamp2 = {
  display: '-webkit-box',
  WebkitLineClamp: 2,
  WebkitBoxOrient: 'vertical',
  overflow: 'hidden',
};

  return (
    <div className={classes.root}>
      <Box
        component="main"
        sx={{ flexGrow: 1, background: '#F2F7F3', height: 'calc(100vh - 86px)' }}
        style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}
        className={classes.padding}
      >
        <Box className={classes.mainContentBox}>
          <Box style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
            <Typography className={classes.mainTitle}>{i18next.t("1. 과제 개요")}</Typography>
            <Box style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
              <Box>
                <IconButton className={clsx(classes.iconBtnReset, classes.moreMenu)} disableRipple onClick={handleClickDotsMoreMenu}>
                  <DotsMoreMenu />
                </IconButton>
                <Popover
                  id="simple-popper"
                  open={!!dotsMoreMenuAnchorEl}
                  anchorEl={dotsMoreMenuAnchorEl}
                  onClose={handleClosePopover}
                  anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                  transformOrigin={{ vertical: 'top', horizontal: 'right' }}
                  className={classes.popoverBox}
                >
                  <Box>
                    <MenuList>
                      <MenuItem onClick={handleClickDelete} disableRipple>
                        <DeleteSubMenu />
                        <Typography className={classes.deleteText}>{i18next.t("과제 삭제")}</Typography>
                      </MenuItem>
                    </MenuList>
                  </Box>
                </Popover>
              </Box>
              <Box>
                <Button className={isNextButtonDisabled ? classes.lineBtn : clsx(classes.lineBtn, classes.lineBtnActive)} onClick={handleClickSave} disabled={isNextButtonDisabled} disableRipple>
                  <Typography>{i18next.t("저장")}</Typography>
                </Button>
              </Box>
              <Box sx={{ marginLeft: "15px" }}>
                <Button className={isNextButtonDisabled ? classes.greenBtn : clsx(classes.greenBtn, classes.greenBtnActive)} onClick={handleClickNextBtn} disabled={isNextButtonDisabled} disableRipple>
                  <Typography>{i18next.t("다음")}</Typography>
                </Button>
              </Box>
            </Box>
          </Box>

		  <Box sx={{ mt:2, mb:2, borderTop: '1px solid #ddd', my: 2 }} />

         {/* 평가 과제명 */}
		<Box
			
			sx={{
				display: 'grid',
				gridTemplateColumns: { xs: '1fr', md: '160px 1fr' }, // same as 교과/과목 row
				alignItems: 'center',
				minHeight: 64,
				mb: 3,
				mt: 3,
				gap: 2,
			}}
			>
			{/* Label */}
			<Typography className={classes.dialogTitle2}>
				{i18next.t("평가 과제명")}
			</Typography>

			{/* Input */}
			<TextField
				sx={{
				'& .MuiOutlinedInput-root': { height: 64 },
				'& .MuiOutlinedInput-input': { py: 2 },
				}}
				id="outlined-basic-project-name"
				autoComplete="off"
				variant="outlined"
				fullWidth                // ⬅️ ensure it stretches across the grid column
				value={projectName}
				onChange={handleChangeName}
				placeholder={i18next.t("최대 {{maxLenName}}자", { maxLenName })}
			/>
		</Box>


        {/* 교과/과목 — 라벨 + 4 셀렉트 */}
		<Box
		sx={{
			display: 'grid',
			gridTemplateColumns: { xs: '1fr', md: '160px 1fr' },
			alignItems: 'center',
			gap: 2,
			mb: 2,
		}}
		>
		<Typography sx={{ fontWeight: 700, color: '#222' }}>
			{i18next.t('교과/과목')}
		</Typography>

		<Box
			sx={{
			display: 'grid',
			gridTemplateColumns: { xs: '1fr', md: 'repeat(4, 1fr)' },
			gap: 2,
			}}
		>
			<FormControl>
			 <Select
				value={selSchool}
				displayEmpty
				onChange={(e) => { setSelSchool(e.target.value === '' ? '' : Number(e.target.value)); resetBelow('school'); }}
			>
				<MenuItem value="">{i18next.t('학교급 선택')}</MenuItem>
				{schoolOpts.map(c => <MenuItem key={c} value={c}>{schoolDict[c]}</MenuItem>)}
			</Select>
			</FormControl>

			<FormControl>
			<Select
				value={selGrade}
				displayEmpty
				disabled={selSchool === ''}                                   // ⬅️ disable
				onChange={(e) => { setSelGrade(e.target.value === '' ? '' : Number(e.target.value)); resetBelow('grade'); }}
			>
				<MenuItem value="">{i18next.t('학년군 선택')}</MenuItem>
				{gradeOpts.map(c => <MenuItem key={c} value={c}>{gradeDict[c]}</MenuItem>)}
			</Select>
			</FormControl>

			<FormControl>
			<Select
				value={selSubjectArea}
				displayEmpty
				disabled={selGrade === ''}                                    // ⬅️ disable
				onChange={(e) => { setSelSubjectArea(e.target.value === '' ? '' : Number(e.target.value)); resetBelow('subjectArea'); }}
			>
				<MenuItem value="">{i18next.t('교과 선택')}</MenuItem>
				{subjectAreaOpts.map(c => <MenuItem key={c} value={c}>{subjectAreaDict[c]}</MenuItem>)}
			</Select>
			</FormControl>

			<FormControl>
			<Select
				value={selSubject}
				displayEmpty
				disabled={selSubjectArea === ''}                               // ⬅️ disable
				onChange={(e) => { setSelSubject(e.target.value === '' ? '' : Number(e.target.value)); resetBelow('subject'); }}
			>
				<MenuItem value="">{i18next.t('과목 선택')}</MenuItem>
				{subjectOpts.map(c => <MenuItem key={c} value={c}>{subjectDict[c]}</MenuItem>)}
			</Select>
			</FormControl>
		</Box>
		</Box>

			{/* 영역(단원) — 라벨 + 1 셀렉트 */}
			<Box
			sx={{
				display: 'grid',
				gridTemplateColumns: { xs: '1fr', md: '160px 1fr' },
				alignItems: 'center',
				gap: 2,
				mb: 2,
			}}
			>
			<Typography sx={{ fontWeight: 700, color: '#222' }}>
				{i18next.t('영역(단원)')}
			</Typography>

			<Box sx={{ display: 'grid', gridTemplateColumns: '1fr', gap: 2 }}>
				<FormControl>
				<Select
					value={selUnit}
					displayEmpty
					disabled={selSubject === ''}                                   // ⬅️ disable
					onChange={(e) => { setSelUnit(e.target.value === '' ? '' : Number(e.target.value)); resetBelow('unit'); }}
				>
					<MenuItem value="">{i18next.t('영역(단원)을 선택해 주세요.')}</MenuItem>
					{unitOpts.map(c => <MenuItem key={c} value={c}>{unitDict[c]}</MenuItem>)}
				</Select>
				</FormControl>
			</Box>
			</Box>

			{/* 성취기준 검색 — 라벨 + (짧은 셀렉트 + 텍스트필드) */}
			<Box
			sx={{
				display: 'grid',
				gridTemplateColumns: { xs: '1fr', md: '160px 1fr' },
				alignItems: 'center',
				gap: 2,
				mb: 2,
			}}
			>
			<Typography sx={{ fontWeight: 700, color: '#222' }}>
				{i18next.t('성취기준 검색')}
			</Typography>

			{/* right side: 2-column controls — fixed width select + flexible text field */}
			<Box
				sx={{
				display: 'grid',
				gridTemplateColumns: { xs: '1fr', md: '260px 1fr' }, // ⬅︎ select shorter here
				gap: 2,
				alignItems: 'center',
				}}
			>
				<FormControl sx={{ minWidth: 200, width: { xs: '100%', md: 260 } }}>
				<Select
					value={selAchievement}
					displayEmpty
					disabled={selUnit === ''}                                      // ⬅️ disable
					onChange={(e) => setSelAchievement(e.target.value === '' ? '' : String(e.target.value))}
				>
					<MenuItem value="">{i18next.t('성취기준 코드')}</MenuItem>
					{achievementOpts.map(code => (
					<MenuItem key={code} value={code}>{code}</MenuItem>
					))}
				</Select>
				</FormControl>

				<TextField
				placeholder={i18next.t('검색어를 입력해 주세요')}
				value={searchTextFree}
				onChange={(e) => setSearchTextFree(e.target.value)}
				variant="outlined"
				fullWidth
				/>
			</Box>
			</Box>
		
			{/* 검색 버튼 (레이아웃만) */}
			<Box sx={{ display: 'flex', justifyContent: 'center', mt: 1, mb: 2 }}>
			


			<Button className={clsx(classes.greenBtn, classes.greenBtnActive)} onClick={() => {
					setApplied({
					school: selSchool,
					grade: selGrade,
					subjectArea: selSubjectArea,
					subject: selSubject,
					unit: selUnit,
					achievement: selAchievement,
					searchText: searchTextFree.trim(),
					});
					setPage(0);
				}} disableRipple>
                  <Typography>{i18next.t("검색")}</Typography>
                </Button>
			</Box>


          {/* Search Results */}
          <Box>
            <Box style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '16px' }}>
              <Typography variant="body1">
                {i18next.t("검색 결과")}: {filteredStandards.length}{i18next.t("건")}
              </Typography>
              <FormControl style={{ minWidth: '120px' }}>
                <Select value={rowsPerPage} onChange={(e) => setRowsPerPage(Number(e.target.value))}>
                  <MenuItem value={10}>10{i18next.t("개씩 보기")}</MenuItem>
                  <MenuItem value={20}>20{i18next.t("개씩 보기")}</MenuItem>
                  <MenuItem value={50}>50{i18next.t("개씩 보기")}</MenuItem>
                </Select>
              </FormControl>
            </Box>

            <TableContainer
				sx={{
					maxHeight: 520,      // ⬅️ set the max height you want
				}}
			>
              <Table
				size="small"
				sx={{
					tableLayout: 'fixed',
					'& .MuiTableCell-root': {
					py: 1.25,
					px: 1,
					borderRight: '1px solid #ddd',   // vertical separator
					},
					'& .MuiTableCell-root:last-of-type': {
					borderRight: 'none',             // remove from last column
					},
				}}
				>

                <TableHead>
                  <TableRow style={{ backgroundColor: '#f5f5f5' }} sx={{borderTop: '1px solid #ddd'}}>
					<TableCell align="center" width='50px'>{i18next.t("번호")}</TableCell>
                    <TableCell width='70px'>{i18next.t("학교급")}</TableCell>
                    <TableCell width='70px'>{i18next.t("학년군")}</TableCell>
                    <TableCell width='80px'>{i18next.t("교과")}</TableCell>
                    <TableCell width='80px'>{i18next.t("과목")}</TableCell>
                    <TableCell width='100px'>{i18next.t("영역(단원)")}</TableCell>
                    <TableCell width='100px'>{i18next.t("성취기준 코드")}</TableCell>
                    <TableCell>{i18next.t("성취기준명")}</TableCell>
					<TableCell align="center" width='50px'>{i18next.t("선택")}</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {paginatedStandards.map((standard, index) => (
                    <TableRow key={standard.id}>
                      <TableCell align="center" sx={{ fontSize: '0.95rem', fontWeight: 600 }}>{index+1}</TableCell>
                      <TableCell >{standard.schoolLevel}</TableCell>
                      <TableCell >{standard.gradeGroup}</TableCell>
                      <TableCell >{standard.subject}</TableCell>
                      <TableCell >{standard.course}</TableCell>
                      <TableCell >{standard.area}</TableCell>
                      <TableCell >{standard.code}</TableCell>
                      <TableCell >{standard.name}</TableCell>
					  <TableCell align="center" padding="checkbox">
						<Radio
						checked={selectedId === standard.id}
						onChange={() => handleSelectStandard(standard.id)}
						value={standard.id}
						inputProps={{ 'aria-label': `select-${standard.id}` }}
						size="small"
						/>
					</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>


            {/* Pagination */}
            <Box className={classes.pageNumber} display='flex' alignItems='center' justifyContent='center'>
              <Stack spacing={2}>
                <Pagination 
                  count={filteredStandards.length > 0 ? Math.ceil(filteredStandards.length / rowsPerPage) : 1}
                  boundaryCount={2}
                  showFirstButton
                  showLastButton
                  onChange={handleClickPage}
                  variant="outlined"
                />
              </Stack>
            </Box>
          </Box>
        </Box>
      </Box>

	  <MessageDialog
				open={openDialog}
				titleText={""}
				children={dialogTitleText[dialogType]}
				isConfirm={dialogIsConfirm[dialogType]}
				onClick={dialogType === 0 ? handleClickTemporalStorage : dialogType === 1 ? handleClickNext : handleClickConfirmBtn}
				onClose={handleClickClose}
			>
			</MessageDialog>
    </div>
  );
}

export default observer<typeof TempProjectCreateBasicInfo>(TempProjectCreateBasicInfo);
